'use strict';

export default {
  fields: {
    fieldErrors: {
      email: 'The email format is invalid',
      date: 'The date is not valid',
      time: 'The time is not valid',
      pastDate: 'The date should be in the past',
      requireCheck: 'The field must be checked',
      requiredField: 'This field is required',
      minMax: 'This field must be between {min} and {max}',
      limit: `{quantityLeft, plural, 
        =0 {There is no more {product} left} 
        other {There is only {quantityLeft} {product} left}
      }`,
    },
  },
};
